import { apiClient, TruckbookApiResponse } from '../axiosClient'

export interface Warehouse {
  acreage: number | null
  address: string
  applyingEndDate: string
  applyingStartDate: string
  cameraUrl: string[]
  companyId: number
  departmentId: number
  id: number
  managerId: number | null
  name: string
  note: string
  postalCode: string
  realEstateId: number | null
  salesOfficeId: number | null
  telNumber: string
  createdAt: string
  createdBy: number
  deletedAt: string | null
  updatedAt: string
  updatedBy: number
}

export interface TenantCheckinTime {
  id: number
  tenantId: number
  dayOfWeek: number
  allowStartTime: string
  allowEndTime: string
  enableFlag: boolean
}

export interface Tenant {
  alertDashboardGeneralReception: boolean
  autoFinish: boolean
  canBerthBook: boolean
  canCardHighlights: boolean
  canCheckin: boolean
  canCopyPaste: boolean | null
  canCustomizeMessage: boolean
  canCustomizeReception: boolean
  canCustomizeReceptionSuperAdminOnly: boolean
  canCustomizeTaskList: boolean | null
  canDriverCheckinCheckoutOnApp: boolean
  canDriverRecordWorkingOnApp: boolean
  canGroupBerth: boolean
  canListCard: boolean
  canOperationCsvDelegation: boolean
  canReceptionUseHistory: boolean
  canSettingCheckinTime: boolean
  canSettingGroup: boolean
  canShowCheckinTime: boolean | null
  canSmartphoneBooking: boolean
  canSms: boolean
  canUnmannedCheckin: boolean
  checkinEnableDistance: number | null
  contactName: string
  contactOption: number
  contactPhone: string
  csvId: string
  driverInfoFlag: boolean
  enableHoliday: boolean | null
  enableSpBookingCutoffLeadtime: boolean
  id: number
  latitude: number | null
  longitude: number | null
  moveUp: boolean
  name: string
  presetMinutesForCheckin: number | null
  showAdditionalColumnActualName: boolean
  showCheckinTimeMode: number
  spBookingCutoffLeadtime: number | null
  tenantNumber: string
  timeWidth: number
  updatedAt: string
  updatedBy: number
  encodedPassword: string
  totalBerths: number
  customBerthLabel: string
  allowCheckin: boolean
  canDriverRecordWorkLogOnReception?: boolean
  tenantCheckinTime?: TenantCheckinTime
  hasCheckoutAdditionalFields: boolean
}

export type GetWarehouseAndTenantResponse = TruckbookApiResponse<{
  warehouse: Warehouse
  tenant: Tenant
}>

export const getWarehouseAndTenant = async (
  warehouseId: string,
  tenantId: string
): Promise<GetWarehouseAndTenantResponse> => {
  const { data } = await apiClient.get<GetWarehouseAndTenantResponse>('/tablets/base_data', {
    params: { warehouseId, tenantId },
  })
  return data
}
